export const rulesViolated = {
    moneyLaundry: 'Geldwäsche',
    fraud: 'Betrug',
    forgery: 'Fälschung',
    theft: 'Diebstahl',
    secondOffence: 'Anderes Vergehen',
    dontKnow: 'Weiß nicht',
};
